import { getApiClient } from './apiService'
import config from '../config/env'

const register = async ({
  email,
  firstName,
  lastName,
  password,
  passwordConfirm,
}) => {
  try {
    const data = {
      email,
      first_name: firstName,
      last_name: lastName,
      password,
      password_confirmation: passwordConfirm,
    }

    const response = await getApiClient().post('/register', data)
    if (response.status === 201 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('login error: ', error)

    let errorMessage = error.message

    if (error?.response?.status === 422) {
      if (
        error?.response?.data?.message === 'The email has already been taken.'
      ) {
        errorMessage = 'Korisnički mail je već zauzet'
      } else {
        errorMessage = error?.response?.data?.message
      }
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const login = async ({ email, password }) => {
  try {
    const response = await getApiClient().post('/login', { email, password })
    if (response.status === 201 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('login error: ', error)
    let errorMessage = error.message

    if (error?.response?.status === 401) {
      errorMessage = error.response.data?.message
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const passwordReset = async ({ email }) => {
  try {
    const response = await getApiClient().post('/password-reset', { email })
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('passwordReset error: ', error)
    let errorMessage = error.message

    if (error?.response?.data?.message) {
      errorMessage = error?.response?.data?.message
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const logout = async () => {
  try {
    const response = await getApiClient().post('/logout')
    if (response.status === 200) {
      return {
        isOk: true,
      }
    } else {
      return {
        isOk: false,
      }
    }
  } catch (error) {
    return {
      isOk: false,
    }
  }
}

const getUserInfo = async ({ userId }) => {
  const url = userId ? `/get-user/${userId}` : `/get-user`

  try {
    const response = await getApiClient().get(url)
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('getUserInfo error: ', error)
    let errorMessage = error.message

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

export const authService = {
  register,
  login,
  logout,
  getUserInfo,
  passwordReset,
}
